import { useContext, useEffect } from 'react';
import { ExperimentationContext } from '../components/context/ExperimentationContext';

export function useLivechat() {
  const experimentation = useContext(ExperimentationContext);

  useEffect(() => {
    if (experimentation.isLivechatIconDisplayed()) {
      const script = document.createElement('script');
      script.src = `${process.env.REACT_APP_PUBLIC_URL_AI_ASSISTANT_JS}`;

      document.body.appendChild(script);

      const link = document.createElement('link');
      link.href = `${process.env.REACT_APP_PUBLIC_URL_AI_ASSISTANT_CSS}`;
      link.rel = 'stylesheet';
      document.head.appendChild(link);

      return () => {
        document.body.removeChild(script);
        document.head.removeChild(link);
      };
    }
    return () => {};
  }, [experimentation]);
}
